module.exports = __webpack_public_path__ + "img/default-upload-content.svg";